module.exports = __webpack_public_path__ + "static/media/eject.53aa7f3b.svg";